class LocalStorage
  get: (key) ->
    JSON.parse localStorage.getItem key

  set: (key, value) ->
    localStorage.setItem key, JSON.stringify(value)

  remove: (key) ->
    localStorage.removeItem key

exports.db = new LocalStorage



// WEBPACK FOOTER //
// ./src/libraries/db.coffee